import React from 'react';

import {getIsBusinessLeader} from '../Dashboard.util';

import {DashboardMetricProps} from './DashboardMetric.types';
import DashboardMetricCards from './DashboardMetricCards';
import {Loading} from './Loading';

export const DashboardMetric = ({
  onShowInfoPopover = () => {},
  onShowReport = () => {},
  hasHomeMetricsById = false,
  currentUserCompetency = '',
}: DashboardMetricProps) => {
  const {isBusinessLeader, isBusinessLeaderOrBusinessCoach} =
    getIsBusinessLeader(currentUserCompetency);

  return hasHomeMetricsById ? (
    <DashboardMetricCards
      isBusinessLeader={isBusinessLeader}
      isBusinessLeaderOrBusinessCoach={isBusinessLeaderOrBusinessCoach}
      onShowInfoPopover={onShowInfoPopover}
      onShowReport={onShowReport}
    />
  ) : (
    <Loading />
  );
};
